import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getLcgEligibility = {
  name: "getLcgEligibility" as const,
  input: z.object({ teamId: zExt.objectId() }),
  // Null until the daily sweep has checked the team.
  output: z
    .object({
      count: z.number(),
      storedOrderCount: z.number().nullable(),
      homeCountryCodes: z.array(z.string()),
      checkedAt: z.date(),
      unavailable: z.boolean(),
      eligible: z.boolean(),
      windowDays: z.number(),
      minOrders: z.number(),
    })
    .nullable(),
};
